import { Routes } from '@angular/router';

import { authGuard } from './auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.routes),
  },
  {
    path: 'security',
    loadChildren: () => import('./profile/security.routes').then((m) => m.routes),
    canActivate: [authGuard]
  },
  {
    path: 'rewards',
    loadChildren: () => import('./poin/poin.routes').then((m) => m.routes),
    canActivate: [authGuard]
  },
  {
    path: 'notifications',
    loadChildren: () => import('./notifications/notifications.route').then((m) => m.routes),
    canActivate: [authGuard]
  },
  {
    path: 'article',
    loadChildren: () => import('./article/article.routes').then((m) => m.routes)
  },
  {
    path: 'misuper',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
    canActivate: [authGuard]
  },
  {
    path: 'superkoffee',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
    canActivate: [authGuard]
  },
  {
    path: 'menus/:brand/:outlet',
    loadComponent: () => import('./menus/menus.page').then(m => m.MenusPage),
  },
  {
    path: 'menu-details/:brand/:outlet/:id',
    loadComponent: () => import('./menus/details/menu-details.page').then(m => m.MenuDetailsPage)
  },
  {
    path: 'cart/:brand/:outlet',
    loadComponent: () => import('./cart/cart.page').then(m => m.CartPage)
  },
  {
    path: 'voucher/:brand',
    loadComponent: () => import('./voucher/voucher.page').then((m) => m.VoucherPage),
  },
  {
    path: 'voucher-details',
    loadComponent: () => import('./voucher/voucher-details/voucher-details.page').then(m => m.VoucherDetailsPage),
  },
  {
    path: 'pesanan-details/:id',
    loadComponent: () => import('./pesanan/pesanan-details/pesanan-details.page').then((m) => m.PesananDetailsPage)
  },
  {
    path: '',
    redirectTo: '/misuper/beranda',
    pathMatch: 'full',
  },
];
